import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.List.IRequest;
type Response = Api.Finance.ContractRefundPayment.List.IResponse;
type Headers = Api.Finance.ContractRefundPayment.List.IHeaders;
const url = '/api/Finance/ContractRefundPayment';
export default async function contractRefundPaymentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
